import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import * as dealApis from "../../utilities/apis/deal"
import Layout from "../../components/Layout"
import Pagination from "../../components/Pagination"

const Deals = () => {
  const navigate = useNavigate()
  const { token, user, permissions } = useSelector(state => state.user)
  const [deals, setDeals] = useState([])
  const [rows, setRows] = useState([])
  const [active, setActive] = useState(1)
  const limit = 10

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete?")) return

      const response = await dealApis.deleteDeal(token, id)
      if (!response.status) throw new Error(response.message)

      setDeals((previous) => {
        const deals = previous.filter(x => x.id !== id)
        return [...deals]
      })
    } catch (error) {
      alert(error.message)
    }
  }

  const getDeals = async () => {
    try {
      const response = await dealApis.getDeals(token, "")
      if (!response.status) throw new Error(response.message)

      setDeals(response.deals)
      setRows(response.deals.slice(0, limit))
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getDeals()
  }, [])

  useEffect(() => {
    setRows(deals.slice((active - 1) * limit, active * limit))
  }, [deals.length])

  useEffect(() => {
    setRows(deals.slice((active - 1) * limit, active * limit))
  }, [active])

  const pages = new Array(Math.ceil(deals.length / limit)).fill(null).map((_, index) => index + 1)

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Deals</p>
            {permissions["CREATE_DEAL"] && <Link to="/dashboard/deal" className="btn btn-theme rounded-4">New</Link>}
          </div>

          <div class="border rounded-4 mb-3">
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "40%" }} className="align-middle">Title</th>
                  <th scope="col" style={{ width: "12%" }} className="align-middle text-center">Cost</th>
                  <th scope="col" style={{ width: "12%" }} className="align-middle text-center">Price</th>
                  <th scope="col" style={{ width: "12%" }} className="align-middle text-center">Discount</th>
                  <th scope="col" style={{ width: "12%" }} className="align-middle text-center">Sale</th>
                  <th scope="col" style={{ width: "12%" }} className="align-middle text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => {
                  let src = "/upload.png"
                  if (row.thumbnail) src = row.thumbnail
                  // if (row.thumbnail_url) src = row.thumbnail_url

                  return (
                    <tr key={row.id.toString()}>
                      <td className="align-middle">
                        <div className="d-flex gap-2 align-items-center">
                          <img src={src} className="rounded-3" alt={row.title} width={40} height={40} />
                          {row.title}
                        </div>
                      </td>
                      <td className="align-middle text-center">Rs. {row.cost?.toFixed(2)}</td>
                      <td className="align-middle text-center">Rs. {row.price?.toFixed(2)}</td>
                      <td className="align-middle text-center">Rs. {row.discount?.toFixed(2)}</td>
                      <td className="align-middle text-center">Rs. {(row.price - row.discount)?.toFixed(2)}</td>
                      <td className="align-middle text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          {permissions["UPDATE_DEAL"] && <Link to={`/dashboard/deal?id=${row.id}`}><i className="far fa-edit"></i></Link>}
                          {permissions["DELETE_DEAL"] && <a className="text-danger" onClick={() => handleDelete(row.id)}><i className="far fa-trash-alt"></i></a>}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <nav aria-label="pagination">
            <Pagination
              currentPage={active}
              totalCount={deals.length}
              pageSize={limit}
              siblingCount={3}
              onPageChange={page => setActive(page)}
            />
          </nav>
        </div>
      </main>
    </Layout>
  )
}

export default Deals
